import angular from 'angular';
import {crud} from '../common/crud/crud.js';
import {FazeForDayComponent} from './fazeForDay.component.js';

const fazaNaloga = angular.module('fazaNaloga', [crud.name]);

fazaNaloga.component('fazeForDay', FazeForDayComponent);

export {fazaNaloga};



// WEBPACK FOOTER //
// ./app/components/fazaNaloga/fazaNaloga.js